import github from './github.png';
import linkedin from './linkedin.jpg';
import instagram from './instagram.png';
import Hackerrank from './hackerrank.png';

const data = [
	{
		name: 'Github',
		text: '@tgovani426',
		cover: github,
		alt: 'github image',
		url: 'https://github.com/tgovani426',
	},
	{
		name: 'Linked In',
		text: 'My linked-in profile...',
		cover: linkedin,
		alt: 'linkedin image',
		url: 'https://www.linkedin.com/in/tirth-govani/',
	},
	{
		name: 'Instagram',
		text: '@tirth_govani :)',
		cover: instagram,
		alt: 'instagram image',
		url: 'https://www.instagram.com/tirth_govani/',
	},
	{
		name: 'Hackerrank',
		text: '@govanitirth',
		cover: Hackerrank,
		alt: 'Hackerrank Image',
		url: 'https://www.hackerrank.com/govanitirth'
	},
	
];

export default data;
